import { Switch, Route } from 'react-router-dom';

import List from './List';
import { Award } from './award/Award';

export default () => {
  const BASE_URL = '/admin/award';

  return (
    <Switch>
      <Route path={[`${BASE_URL}`]} component={List} exact />
      <Route path={[`${BASE_URL}/:award`, `${BASE_URL}/new`]} component={Award} />
    </Switch>
  );
};
